import { defineElement } from '@webtides/element-js';

import SocialMediaWallElement from './social-media-wall-element.class';
import SocialMediaWallChannelButtons from './social-media-wall-channel-buttons.class';
import SocialMediaWallPosts from './social-media-wall-posts.class';
import SocialMediaWallPagination from './social-media-wall-pagination';

defineElement('social-media-wall-element', SocialMediaWallElement);
defineElement('social-media-wall-channel-buttons', SocialMediaWallChannelButtons);
defineElement('social-media-wall-posts', SocialMediaWallPosts);
defineElement('social-media-wall-pagination', SocialMediaWallPagination);
